// Hide the sticky announcement bar + header when scrolling down, reveal them when scrolling up.
(() => {
  const root = document.documentElement;
  const TOLERANCE = 6; // px of scroll needed before reacting, avoids jitter
  let lastY = window.scrollY;
  let stackHeight = 0;

  const measure = () => {
    stackHeight = 0;
    document
      .querySelectorAll(
        '.shopify-section-group-header-group.announcement-bar-wrapper, .shopify-section-group-header-group.header-section'
      )
      .forEach((section) => {
        const top = parseFloat(getComputedStyle(section).top) || 0;
        stackHeight = Math.max(stackHeight, top + section.offsetHeight);
      });
    root.style.setProperty('--header-scroll-hide-offset', `${stackHeight}px`);
  };

  // A dropdown / mega menu lives inside the header: never hide the header while one is open, or the menu
  // slides away from under the pointer, closes, and reopens (flicker)
  const menuOpen = () =>
    !!document.querySelector(
      'header-wrapper .submenu.is-open, header-wrapper .submenu.is-opening, header-wrapper .submenu.is-closing'
    );

  // Pointer or keyboard focus on the header keeps it in place (was a body:has(:hover) CSS rule, too costly)
  const headerSection = document.querySelector('.shopify-section-group-header-group.header-section');
  const headerHeld = () => !!headerSection && headerSection.matches(':hover, :focus-within');

  const onScroll = () => {
    const y = Math.max(window.scrollY, 0);
    const delta = y - lastY;

    if (menuOpen() || headerHeld()) {
      root.classList.remove('header-scroll-hidden');
      lastY = y;
      return;
    }

    if (y <= stackHeight) {
      root.classList.remove('header-scroll-hidden');
    } else if (Math.abs(delta) >= TOLERANCE) {
      root.classList.toggle('header-scroll-hidden', delta > 0);
    } else {
      return;
    }

    lastY = y;
  };

  measure();
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('load', measure);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
